import { useAppConfigStore } from '@prodelio/config/state/app-config/AppConfig';

export const useViewConfig = (view = '') => {
  const { views, global } = useAppConfigStore(({ config }) => config);

  return views[view] || global.views;
};
